// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"1fe338f9","78":"72729d21","197":"b29da3ab","275":"84796400","567":"6512e781"}[chunkId] + ".chunk.css";
};